
import React, { useState } from 'react'
import {  DescIcon,  Ctitle,  Descp, Cicon, Content } from './style'
import closeIcon from '@/img/user-new/close-circle.png'
// import descSrc from '@/img/user-new/desc-icon.png'
import Slice2 from './../../img/Slice2.png'

// Slice2.png
import { Modal } from 'antd-mobile'


const Desc = () => {
	const [descVisible, setDescVisible] = useState(false)
	return (
		<React.Fragment>
			<DescIcon className={'ac-desc'} src={Slice2} alt="" onClick={() => setDescVisible(true)} />
				
			<Modal visible={descVisible} 
			title={
				<React.Fragment>
					<Ctitle>
						<div className={'title'}>
						<img src={require('./../../img/modal_title2.png')} alt="标题" />
						</div>
					</Ctitle>
					<Cicon src={closeIcon} alt="e"  onClick={() => setDescVisible(false)}></Cicon>
				</React.Fragment>
     }
			wrapClassName="lx-desc-modal-outer" className={'un-desc-modal un-desc-modal2  long-modal'} 
			transparent onClose={() => setDescVisible(false)}>
				<Content>
					<Descp>一、活动规则</Descp>
					<Descp>1.风云新秀养成计划，是市值风云百万补贴针对新注册的创作者激励计划。通过发布单篇符合质量标准的文章&帖子等内容（不含违规）的完成每日的任务要求且累计打卡即可瓜分现金奖励。</Descp>
					<Descp>2.新注册用户：指从未在市值风云官方平台注册过的用户。 </Descp>
					<Descp>3.活动有效期：从注册日起，30日内完成对应任务即可满足兑奖条件。</Descp>
					<Descp>4.奖励结算：次月10日左右统一通过赞赏功能发放奖励。 (开通赞赏入口：我的-创作中心-赞赏） 投稿体裁：帖子、文章。</Descp>
					<Descp>二、参与方式</Descp>
					<Descp>活动任务要求：在市值风云平台创作、成功发布具有个股、指数、概念、板块等内容且满足活动任务要求即视为参与。</Descp>
					<Descp>三、活动任务说明</Descp>

					<Descp>符合以下任务条件的用户满足7日、14日、21日任务的要求即可瓜分对应奖池金额每日打卡任务： </Descp>
					<Descp>1.发布原创投资个股相关内容3篇且>=30字以上。</Descp>
					<Descp>2.去点赞他人内容5篇</Descp>
					<Descp>3.发10字以上评论5条</Descp>
					<Descp>首发任务：首次发布原创个股投资相关内容1篇且30字以上即可随机获得1-8元现金奖励。</Descp>
					<Descp>惊喜任务：30天内完成涨粉100个额外必得18元现金奖励红包</Descp>
					<table style={{"width":"100%", textAlign:'center',}}>
						<tr><td>任务类型</td><td>奖励内容</td></tr>
						<tr><td>首次必得</td><td>随机1-8元</td></tr>
						<tr><td>累计7日打卡</td><td>瓜分688元</td></tr>
						<tr><td>累计14日打卡</td><td>瓜分1688元</td></tr>
						<tr><td>累计21日打卡</td><td>瓜分3888元</td></tr>
						<tr><td>惊喜任务</td><td>必得18元</td></tr>
					</table>
					<Descp>四、免责说明</Descp>
				
					<Descp>1.本活动鼓励、支持内容原创、参与活动的用户应采用原创内容投稿参与本活动，且保证在本次投稿前相关内容未发布在本平台。如平台发现参与活动的内容未搬运、抄袭等非原创内容，平台有权进行相应处理，包括不限于：删除、隐藏对应内容，取消参与活动、评选获奖的资格，并进行处罚，公示。</Descp>
					<Descp>2.参与活动发布的内容，需遵守市值风云社区规范、本活动对投稿内容的相关要求。如平台发现用户通过不正当行为参与本活动，如恶意解读活动规则、恶意投稿与活动要求无关的内容、故意刷量、作弊、展示和诱导其他用户骗取点击互动等，以获取活动奖励，一经发现，有权采取措施，包括不限于：降低/取消活动奖励、撤销活动资格、限制提现、封禁账号等。</Descp>
				</Content>
					{/* <div style={{height: '30px'}}></div> */}
			</Modal>
		</React.Fragment>
	)
}
export default Desc


// WEBPACK FOOTER //
// ./src/views/activity_170/componens/Desc/index.js